import React, {Component} from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import * as ReactBootStrap from 'react-bootstrap';

import megusto from '../tools/images/iconomegustogris.svg'
import nomegusto from '../tools/images/icononomegusto.svg'
import meinteresa from '../tools/images/iconomeinteresa.svg'

import Reaccion_megusto from '../tools/images/iconomegusto.svg'
import Reaccion_nomegusto from '../tools/images/icononomegustomagenta.svg'
import Reaccion_meinteresa from '../tools/images/iconomeinteresamagenta.svg'

import cargamultimedia from '../tools/images/iconocargarfoto.svg'

import emptypage from '../tools/images/carpeta.gif';
import img_vacia from '../tools/images/imagen portada.jpg';
import Buscar from '../tools/images/Buscar';

import AwesomeSlider from 'react-awesome-slider';
import Estilo from 'react-awesome-slider/dist/styles.css';

import '../tools/css/Publicaciones.css';

import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';

import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

// ---------------------------------------------------------------------------
// Constantes del módulo. institution_id/FILES_BASE_URL no cambian durante la
// vida del componente, así que no necesitan vivir en el estado de React.
// ---------------------------------------------------------------------------
const ApiURL = "https://medicall-api-test.azurewebsites.net";
const INSTITUTION_ID = sessionStorage.getItem('id_institution');
const FILES_BASE_URL = ApiURL + "/api/Files?path=";

// Avatar de reserva (silueta gris) para usuarios que reaccionaron sin foto de perfil.
const AVATAR_POR_DEFECTO = "data:image/svg+xml;utf8," + encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'><circle cx='20' cy='20' r='20' fill='#e0e0e0'/><circle cx='20' cy='16' r='7' fill='#ffffff'/><path d='M6 35c0-9 7-14 14-14s14 5 14 14' fill='#ffffff'/></svg>"
)

// A partir de cuántos caracteres se ofrece el botón "Ver más" (heurística:
// no medimos el alto real renderizado, así que esto aproxima "más de 3 líneas").
const UMBRAL_VER_MAS = 220;


class Publicaciones_prestador extends Component {

  constructor(props) {
    super(props)

    this.state = {
      // Institución dueña de las publicaciones (para el header de cada card).
      institucion: {},

      // Listado principal + paginación.
      publicaciones: [],
      paginasPublicaciones: [],
      infoPaginaPublicaciones: '',
      cargandoPublicaciones: true,
      textoBusqueda: '',

      // Qué descripciones están expandidas ("Ver más"/"Ver menos"), por id de publicación.
      descripcionesExpandidas: {},

      // Formulario "Crear publicación".
      publicarPara: '',
      descripcionNueva: '',
      archivosNuevos: [],
      guardandoPublicacion: false,

      // Formulario "Editar publicación".
      publicacionEditando: null,
      descripcionEditada: '',
      guardandoEdicion: false,

      // Publicación que se va a eliminar (modal de confirmación).
      publicacionAEliminar: null,

      // Detalle de un archivo (imagen o video) al hacer clic en el slider.
      publicacionDetalle: null,
      archivoDetalle: null,

      // Modal de reacciones (me gustó / no me gustó / me interesa).
      publicacionParaReaccion: null,
      tipoReaccionSeleccionado: '',
      listaReacciones: []
    }
  }

  componentDidMount() {
    this.cargarDatosInstitucion()
    this.cargarPublicaciones()
  }


  // ===========================================================================
  // Utilidades
  // ===========================================================================

  /** Notificación estándar (toast) — evita repetir la misma configuración en cada llamada. */
  notificar(tipo, titulo, mensaje) {
    store.addNotification({
      title: titulo,
      message: mensaje,
      type: tipo, // 'default' | 'success' | 'info' | 'warning' | 'danger'
      container: 'top-right',
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 10000, showIcon: true }
    })
  }

  /** Manejo estándar de errores de axios: usa el mensaje del backend si vino, si no solo lo deja en consola. */
  manejarErrorApi(error) {
    if (error.response) {
      this.notificar('danger', 'Atención', error.response.data.message || 'Ocurrió un error inesperado')
    } else if (error.request) {
      console.log(error.request)
    } else {
      console.log('Error', error.message)
    }
  }

  /** "juan pérez" -> "Juan Pérez" */
  capitalizarTexto(texto) {
    return (texto || '').trim().toLowerCase().replace(/\w\S*/g, (palabra) => palabra.replace(/^\w/, (letra) => letra.toUpperCase()))
  }

  /** Detecta si el recurso de una publicación es un video por su extensión en la URL. */
  esVideo(url) {
    if (!url) return false
    return /\.(mp4|mov|avi|wmv|webm|mkv)(\?|$)/i.test(url)
  }

  obtenerNombreInstitucion() {
    return this.state.institucion.name ? this.capitalizarTexto(this.state.institucion.name) : ''
  }

  /** Las 3 opciones del select "Publicar para" quedan más legibles en el pie de cada card. */
  formatearAudiencia(valor) {
    const etiquetas = { publico: 'Público', profesionales: 'Profesionales de la salud', pacientes: 'Pacientes' }
    return etiquetas[valor] || valor
  }

  /** Ícono/título/total a mostrar en el modal de reacciones, según cuál se pidió ver. */
  obtenerInfoReaccion() {
    const { tipoReaccionSeleccionado, publicacionParaReaccion } = this.state

    if (!publicacionParaReaccion) return { icono: '', titulo: '', total: 0 }

    if (tipoReaccionSeleccionado === 'me gustó') {
      return { icono: Reaccion_megusto, titulo: 'Esta publicación le gustó a', total: publicacionParaReaccion.likes }
    }
    if (tipoReaccionSeleccionado === 'no me gustó') {
      return { icono: Reaccion_nomegusto, titulo: 'Esta publicación no le gustó a', total: publicacionParaReaccion.notLikes }
    }
    return { icono: Reaccion_meinteresa, titulo: 'Esta publicación le interesa a', total: publicacionParaReaccion.interested }
  }


  // ===========================================================================
  // Carga de datos (API)
  // ===========================================================================

  cargarDatosInstitucion() {
    axios.get(ApiURL + "/api/Institutions/GetInstitution/" + INSTITUTION_ID)
      .then((response) => {
        this.setState({ institucion: response.data.institution })
      })
      .catch((error) => console.log(error))
  }

  cargarPublicaciones() {
    this.ocultarEstadosDeListado()
    this.setState({ cargandoPublicaciones: true })

    axios.get(ApiURL + "/api/Posts/GetPostInstitution?id=" + INSTITUTION_ID)
      .then((response) => this.aplicarRespuestaPublicaciones(response))
      .catch((error) => console.log(error))
  }

  irAPaginaPublicaciones(pagina) {
    this.setState({ cargandoPublicaciones: true })

    axios.get(ApiURL + "/api/Posts/GetPostInstitution?id=" + INSTITUTION_ID + "&numeropagina=" + pagina.pagina)
      .then((response) => this.aplicarRespuestaPublicaciones(response))
      .catch((error) => console.log(error))
  }

  buscarPublicaciones(texto) {
    this.setState({ cargandoPublicaciones: true })

    axios.get(ApiURL + "/api/Posts/GetPostInstitution?id=" + INSTITUTION_ID + "&texto=" + texto)
      .then((response) => this.aplicarRespuestaPublicaciones(response))
      .catch((error) => console.log(error))
  }

  /** Común a cargar/paginar/buscar: guarda el listado + pager y decide si se ve la lista o el estado vacío. */
  aplicarRespuestaPublicaciones(response) {
    const publicaciones = response.data.data

    this.setState({
      publicaciones,
      paginasPublicaciones: response.data.pager.items,
      infoPaginaPublicaciones: response.data.pager.showData,
      cargandoPublicaciones: false
    })

    if (publicaciones.length === 0) {
      $('#tabla_p').hide()
      $('#empty_page').show()
      $('#text_page').show()
    } else {
      $('#tabla_p').show()
      $('#empty_page').hide()
      $('#text_page').hide()
    }
  }

  ocultarEstadosDeListado() {
    $('#tabla_p').hide()
    $('#empty_page').hide()
    $('#text_page').hide()
  }


  // ===========================================================================
  // Formulario "Crear publicación"
  // ===========================================================================

  abrirModalNuevaPublicacion() {
    $('#input_file').show()
    $('#tabla_imgs').hide()
    $('#btn_cancelar_seleccion').hide()
    $('#modal-agregar-publicacion').modal('show')

    this.setState({ descripcionNueva: '', archivosNuevos: [], publicarPara: '' })
  }

  cerrarModalNuevaPublicacion() {
    $('#tabla_imgs').hide()
    $('#btn_cancelar_seleccion').hide()
    $("#tipo_publicacion").val($('#tipo_publicacion > option:first').val())

    this.setState({ descripcionNueva: '', archivosNuevos: [], publicarPara: '' })
  }

  manejarCambioPublicarPara = (evento) => {
    this.setState({ publicarPara: evento.target.value })
  }

  /** onChange genérico para inputs de texto controlados por this.state[name]. */
  manejarCambioTexto = (evento) => {
    this.setState({ [evento.target.name]: evento.target.value })
  }

  /** Un solo input ya acepta imágenes y video (ver el atributo "accept" del <input>). */
  manejarSeleccionArchivos = (evento) => {
    const archivos = evento.target.files

    if (archivos.length > 10) {
      this.notificar('danger', 'Atención', 'No puede seleccionar más de 10 archivos para una publicación')
      return
    }

    this.setState({ archivosNuevos: archivos })
    $('#input_file').hide()
    $('#tabla_imgs').show()
    $('#btn_cancelar_seleccion').show()
  }

  cancelarSeleccionArchivos() {
    this.setState({ archivosNuevos: [] })
    $('#input_file').show()
    $('#tabla_imgs').hide()
    $('#btn_cancelar_seleccion').hide()
  }

  textoArchivosSeleccionados() {
    const cantidad = this.state.archivosNuevos.length
    return cantidad > 0 ? `Ha seleccionado ${cantidad} archivo(s)` : 'Ningún archivo seleccionado'
  }

  guardarPublicacion = async () => {
    const { archivosNuevos, publicarPara, descripcionNueva } = this.state

    if (!publicarPara || !descripcionNueva.trim() || archivosNuevos.length === 0) {
      this.notificar('danger', 'Atención', 'Faltan datos por ingresar')
      return
    }

    this.setState({ guardandoPublicacion: true })

    const formData = new FormData()
    formData.append('Description', descripcionNueva)
    for (const archivo of archivosNuevos) {
      formData.append('Resources', archivo, archivo.name)
    }
    formData.append('public', publicarPara)

    try {
      await axios.post(ApiURL + "/api/Posts/Create", formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })

      this.notificar('success', 'Muy bien', "La publicación se guardó")
      $('#modal-agregar-publicacion').modal('hide')
      this.cerrarModalNuevaPublicacion()
      this.cargarPublicaciones()
    } catch (error) {
      this.manejarErrorApi(error)
    } finally {
      this.setState({ guardandoPublicacion: false })
    }
  }


  // ===========================================================================
  // Editar / eliminar publicación
  // ===========================================================================

  abrirModalEditar(publicacion) {
    this.setState({ publicacionEditando: publicacion, descripcionEditada: publicacion.description })
    $('#modal-publicacionedit').modal('show')
  }

  guardarEdicion = async () => {
    const { publicacionEditando, descripcionEditada } = this.state

    if (!publicacionEditando || !descripcionEditada.trim()) {
      this.notificar('danger', 'Atención', 'Faltan datos por ingresar')
      return
    }

    this.setState({ guardandoEdicion: true })

    try {
      const response = await axios.put(ApiURL + "/api/Posts/EditDescription", {
        id: publicacionEditando.id,
        description: descripcionEditada
      })

      this.notificar('success', 'Muy bien', response.data.message)
      this.cargarPublicaciones()
      $('#modal-publicacionedit').modal('hide')
    } catch (error) {
      this.manejarErrorApi(error)
    } finally {
      this.setState({ guardandoEdicion: false })
    }
  }

  confirmarEliminarPublicacion(publicacion) {
    this.setState({ publicacionAEliminar: publicacion })
    $('#modal-eliminar_publicacion').modal('show')
  }

  eliminarPublicacion = async () => {
    const { publicacionAEliminar } = this.state
    if (!publicacionAEliminar) return

    try {
      const response = await axios.delete(ApiURL + "/api/Posts/Delete/" + publicacionAEliminar.id)
      this.notificar('success', 'Muy bien', response.data.message)
      this.cargarPublicaciones()
    } catch (error) {
      this.manejarErrorApi(error)
    }
  }


  // ===========================================================================
  // Detalle de un archivo (modal grande) y reacciones
  // ===========================================================================

  abrirDetallePublicacion(publicacion, archivo) {
    this.setState({ publicacionDetalle: publicacion, archivoDetalle: archivo })

    if (this.esVideo(archivo.image)) {
      $('#imgsdetalle').hide()
      $('#vdsdetalle').show()
    } else {
      $('#imgsdetalle').show()
      $('#vdsdetalle').hide()
    }

    $('#modal-detallepubli').modal('show')
  }

  cerrarDetalleArchivo() {
    this.setState({ archivoDetalle: null })
  }

  cargarReacciones(publicacion, tipo) {
    this.setState({ tipoReaccionSeleccionado: tipo, publicacionParaReaccion: publicacion })

    axios.get(ApiURL + "/api/Posts/GetInfoReact?postId=" + publicacion.id + "&type=" + tipo)
      .then((response) => {
        this.setState({ listaReacciones: response.data })
        $('#modal-reacciones').modal('show')
      })
      .catch((error) => console.log(error))
  }

  alternarDescripcion(id) {
    this.setState((previo) => ({
      descripcionesExpandidas: { ...previo.descripcionesExpandidas, [id]: !previo.descripcionesExpandidas[id] }
    }))
  }


  // ===========================================================================
  // Sub-render: un botón de reacción (me gustó / no me gustó / me interesa).
  // Sin reacciones se ve neutro y sin clic; con reacciones muestra el contador
  // y abre el modal de quién reaccionó.
  // ===========================================================================

  renderBotonReaccion(publicacion, tipo, opciones) {
    const { cantidad, etiqueta, iconoInactivo, iconoActivo } = opciones
    const activa = cantidad > 0

    return (
      <button
        type="button"
        className={"feed-post__reaction" + (activa ? " feed-post__reaction--active" : "")}
        disabled={!activa}
        onClick={activa ? () => this.cargarReacciones(publicacion, tipo) : undefined}
      >
        <img src={activa ? iconoActivo : iconoInactivo} alt={etiqueta} />
        <span>{etiqueta}</span>
        {activa ? <span className="feed-post__reaction-count">{cantidad}</span> : null}
      </button>
    )
  }


  // ===========================================================================
  // Sub-render: una card de publicación completa (header, slider, reacciones,
  // descripción con "Ver más/Ver menos").
  // ===========================================================================

  renderTarjetaPublicacion(publicacion) {
    const archivos = publicacion.resourcePosts || []
    const expandida = !!this.state.descripcionesExpandidas[publicacion.id]
    const necesitaVerMas = (publicacion.description || '').length > UMBRAL_VER_MAS
    const nombreInstitucion = this.obtenerNombreInstitucion()

    return (
      <div className="feed-post" key={publicacion.id}>

        <div className="feed-post__header">
          <img className="feed-post__avatar" src={FILES_BASE_URL + this.state.institucion.avatar} alt={nombreInstitucion} />
          <div className="feed-post__meta">
            <span className="feed-post__author">{nombreInstitucion}</span>
            <span className="feed-post__time"><Moment fromNow locale='es'>{publicacion.date}</Moment></span>
          </div>

          <div className="feed-post__menu btn-group dropleft">
            <button type="button" className="feed-post__menu-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
              </svg>
            </button>
            <div className="dropdown-menu">
              <a className="dropdown-item" href="#" onClick={() => this.abrirModalEditar(publicacion)}>Editar</a>
              <a className="dropdown-item" href="#" onClick={() => this.confirmarEliminarPublicacion(publicacion)}>Eliminar</a>
            </div>
          </div>
        </div>

        <div className="feed-post__media">
          <AwesomeSlider cssModule={Estilo}>
            {archivos.map((archivo, indice) => {
              const url = FILES_BASE_URL + archivo.image
              const video = this.esVideo(archivo.image)

              return (
                <div key={indice} className="feed-post__slide">
                  {video ? (
                    // Con controles reales: se puede reproducir directo en el feed, sin pasar por el modal.
                    <video src={url} className="feed-post__media-el" controls preload="metadata" />
                  ) : (
                    <img
                      src={url}
                      className="feed-post__media-el feed-post__media-el--clickable"
                      alt="Publicación"
                      onClick={() => this.abrirDetallePublicacion(publicacion, archivo)}
                    />
                  )}
                </div>
              )
            })}
          </AwesomeSlider>
        </div>

        <div className="feed-post__body">
          <div className="feed-post__actions">

            {this.renderBotonReaccion(publicacion, 'me gustó', {
              cantidad: publicacion.likes, etiqueta: 'Me gustó', iconoInactivo: megusto, iconoActivo: Reaccion_megusto
            })}

            {this.renderBotonReaccion(publicacion, 'no me gustó', {
              cantidad: publicacion.notLikes, etiqueta: 'No me gustó', iconoInactivo: nomegusto, iconoActivo: Reaccion_nomegusto
            })}

            {this.renderBotonReaccion(publicacion, 'me interesa', {
              cantidad: publicacion.interested, etiqueta: 'Me interesa', iconoInactivo: meinteresa, iconoActivo: Reaccion_meinteresa
            })}

          </div>

          <p className={"feed-post__description" + (necesitaVerMas && !expandida ? " feed-post__description--clamped" : "")}>
            {publicacion.description}
          </p>

          {necesitaVerMas ? (
            <button type="button" className="feed-post__toggle" onClick={() => this.alternarDescripcion(publicacion.id)}>
              {expandida ? 'Ver menos' : 'Ver más'}
            </button>
          ) : null}

          <div className="feed-post__audience">
            <i className="fas fa-users"></i> Publicado para: {this.formatearAudiencia(publicacion.public)}
          </div>

        </div>
      </div>
    )
  }


  // ===========================================================================
  // Sub-render: modales
  // ===========================================================================

  renderModalNuevaPublicacion() {
    return (
      <div className="modal fade" id="modal-agregar-publicacion" data-backdrop="static">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header feed-modal-header">
              <h4 className="col-11 modal-title text-center"><b>Crear publicación</b></h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.cerrarModalNuevaPublicacion()}>
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row justify-content-md-center">

                <div className="col-md-6">

                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Publicar para:</label>
                        <select onChange={this.manejarCambioPublicarPara} className="form-control" id="tipo_publicacion" name="tipo_publicacion" value={this.state.publicarPara}>
                          <option value="">Seleccione...</option>
                          <option value="publico">Publico</option>
                          <option value="profesionales">Profesionales de la salud</option>
                          <option value="pacientes">Pacientes</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row" id="input_file">
                    <div className="col-md-12 col-auto text-center">
                      <div className="form-group">
                        <label>Seleccione los archivos</label>
                        <div className="custom-file">
                          <input type="file" name="selectedFile" id="exampleInputFile" multiple className="inputfile inputfile-5" accept="image/jpg,image/jpeg,image/bmp,image/png,video/avi,video/mp4,video/wmv" onChange={this.manejarSeleccionArchivos} />
                          <label htmlFor="exampleInputFile">
                            <figure><img src={cargamultimedia} alt="Cargar archivos" /></figure>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row" id="tabla_imgs">
                    <div className="col-md-12">
                      {[...this.state.archivosNuevos].map((archivo, indice) => {
                        const url = URL.createObjectURL(archivo)
                        if (/^image\/\S+$/.test(archivo.type)) {
                          return <img key={indice} id="imgs" src={url} alt="Vista previa" width="350" className="rounded" />
                        }
                        if (/^video\/\S+$/.test(archivo.type)) {
                          return <video key={indice} id="vdos" src={url} width="350" loop controls />
                        }
                        return null
                      })}
                    </div>
                  </div>

                  <br/>
                  {this.textoArchivosSeleccionados()}
                  <br/>

                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label>Descripción de la publicación:</label>
                    <textarea className="form-control" rows="14" id="descrip_publi" name="descripcionNueva" placeholder="Ingrese el texto de la publicación..." value={this.state.descripcionNueva} onChange={this.manejarCambioTexto} />
                  </div>
                </div>

              </div>
            </div>

            <div className="modal-footer justify-content-between">
              <button type="button" className="btn btn-primary" disabled={this.state.guardandoPublicacion} onClick={() => this.guardarPublicacion()}>
                {this.state.guardandoPublicacion ? <ReactBootStrap.Spinner animation="border" size="sm" /> : null} Publicar
              </button>
              <button type="button" id="btn_cancelar_seleccion" className="btn btn-default" disabled={this.state.guardandoPublicacion} onClick={() => this.cancelarSeleccionArchivos()}>Cancelar selección</button>
              <button type="button" className="btn btn-danger" disabled={this.state.guardandoPublicacion} data-dismiss="modal" onClick={() => this.cerrarModalNuevaPublicacion()}>Cerrar</button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderModalEditarPublicacion() {
    return (
      <div className="modal fade" id="modal-publicacionedit">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header feed-modal-header">
              <h4 className="modal-title"><b>Editar publicación</b></h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Descripción de la publicación:</label>
                    <textarea className="form-control" rows="6" id="descrip_publi_edit" name="descripcionEditada" value={this.state.descripcionEditada} onChange={this.manejarCambioTexto} />
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-between">
              <button type="button" className="btn btn-primary" disabled={this.state.guardandoEdicion} onClick={() => this.guardarEdicion()}>
                {this.state.guardandoEdicion ? <ReactBootStrap.Spinner animation="border" size="sm" /> : null} Guardar
              </button>
              <button type="button" className="btn btn-danger" data-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderModalDetalle() {
    const { publicacionDetalle, archivoDetalle } = this.state
    const nombreInstitucion = this.obtenerNombreInstitucion()
    const urlDetalle = archivoDetalle ? FILES_BASE_URL + archivoDetalle.image : img_vacia

    return (
      <div className="modal fade" id="modal-detallepubli" data-backdrop="static">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header feed-modal-header">
              <h4 className="modal-title">
                <img id="image_publi" src={FILES_BASE_URL + this.state.institucion.avatar} width="60" className="rounded-circle" alt={nombreInstitucion} />
              </h4>
              <h5>
                <small>{nombreInstitucion}</small> <br/>
                <small>{publicacionDetalle ? <Moment fromNow locale='es'>{publicacionDetalle.date}</Moment> : null}</small>
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.cerrarDetalleArchivo()}>
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row justify-content-md-center" id="tabla_imgsdetalle">
                <div className="col col-lg-12">
                  <img id="imgsdetalle" src={urlDetalle} className="rounded" alt="Detalle de la publicación" />
                  <video id="vdsdetalle" src={urlDetalle} className="rounded" controls autoPlay />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderModalEliminar() {
    return (
      <div className="modal fade" id="modal-eliminar_publicacion" data-backdrop="static">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header feed-modal-header">
              <h4 className="modal-title"><b>Atención</b></h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-md-12">
                Si eliminas la publicación no se podrá recuperar.
                <br/><br/>
                ¿Estás seguro que la deseas eliminar?
              </div>
            </div>
            <div className="modal-footer justify-content-between">
              <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => this.eliminarPublicacion()}>Si</button>
              <button type="button" className="btn btn-danger" data-dismiss="modal">No</button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderModalReacciones() {
    const info = this.obtenerInfoReaccion()

    return (
      <div className="modal fade" id="modal-reacciones" data-backdrop="static">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header feed-modal-header">
              <h5 className="modal-title"><b>{info.titulo + " " + info.total + " persona(s)"}</b></h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body" id="tabla_reacciones">
              {this.state.listaReacciones.map((reaccion, indice) => (
                <a className="dropdown-item" key={indice}>
                  <div className="media">
                    <img id="image_publi" src={reaccion.user.avatar ? FILES_BASE_URL+reaccion.user.avatar : AVATAR_POR_DEFECTO} width="40" className="mr-3 rounded-circle" alt={reaccion.user.name} onError={(e) => { e.target.onerror = null; e.target.src = AVATAR_POR_DEFECTO }} />
                    <div className="media-body">
                      <h3 className="dropdown-item-title">
                        <b>{this.capitalizarTexto(reaccion.user.name)}</b>
                        <span className="float-right text-sm text-danger"><img src={info.icono} alt="Reacción" width="25" /></span>
                      </h3>
                      {this.state.tipoReaccionSeleccionado === 'me interesa' ? (
                        <div id="info_reaccion">
                          <spam>Cel: {reaccion.user.phone}</spam><br/>
                          <spam>Correo: {reaccion.user.email}</spam>
                        </div>
                      ) : null}
                      <p className="text-sm text-muted"><i className="far fa-clock mr-1" /> <Moment fromNow locale='es'>{reaccion.date}</Moment></p>
                    </div>
                  </div>
                  <div className="dropdown-divider"> </div>
                </a>
              ))}
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-danger" data-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>
    )
  }


  // ===========================================================================
  // Render principal
  // ===========================================================================

  render() {
    return (
      <div className="content-wrapper">
        <div className="col-12 col-sm-12 feed-page">

          <div className="feed-toolbar feed-toolbar--with-button">
            <span className="feed-toolbar__spacer"></span>
            <h1 className="feed-toolbar__title feed-toolbar__title--brand">PUBLICACIONES</h1>
            <button type="button" className="feed-toolbar__button" onClick={() => this.abrirModalNuevaPublicacion()}>
              <i className="fas fa-plus"></i> Nueva publicación
            </button>
          </div>

          <div className="feed-search">
            <Buscar/>
            <input type="search" className="feed-search__input" placeholder="Buscar publicaciones..." name="buscar_solicitadas" onChange={(evento) => { this.setState({ textoBusqueda: evento.target.value }); this.buscarPublicaciones(evento.target.value) }} />
          </div>

          <div className="feed-loading">
            {this.state.cargandoPublicaciones ? <ReactBootStrap.Spinner animation="border" /> : null}
          </div>

          <div id="tabla_p">

            {this.state.publicaciones.map((publicacion) => this.renderTarjetaPublicacion(publicacion))}

            <span className="text-muted">{this.state.infoPaginaPublicaciones}</span>
            <nav className="feed-pagination">
              <ul className="pagination">
                {this.state.paginasPublicaciones.map((pagina, indice) => (
                  <li key={indice} className={pagina.activo ? 'page-item active' : 'page-item'}>
                    <a className="nav-link" onClick={() => this.irAPaginaPublicaciones(pagina)}>{pagina.texto}</a>
                  </li>
                ))}
              </ul>
            </nav>

          </div>

          <div className="feed-empty">
            <img id="empty_page" src={emptypage} alt="Sin publicaciones" width="160" />
            <h5 id="text_page"><b>No hay información que mostrar</b></h5>
          </div>

        </div>

        {this.renderModalNuevaPublicacion()}
        {this.renderModalEditarPublicacion()}
        {this.renderModalDetalle()}
        {this.renderModalEliminar()}
        {this.renderModalReacciones()}

      </div>
    )
  }

}

export default Publicaciones_prestador;
